<template>
	<b-modal ref="messsage-modal" title="Message" v-model="show_message" :modal-class="'no-header no-footer'" size="md">

		<form @submit.prevent="submit" :disabled="sending">
			<div class="text-uppercase d-flex align-items-center">
				<div class="flex-grow-1 text-success" v-if="selected_workers.length > 1">
					Message to assets:
					</div>
				<div class="flex-grow-1 text-success" v-else>
					Message to {{ $worker.getName(selected_workers[0]) }}
				</div>

				<button type="button" class="btn btn-light mr-2 border border-dark" @click="show_message = false" :disabled="sending">CANCEL</button>
				<button type="submit" class="btn border border-dark" :class="{'btn-dark' : !option || sending, 'btn-success': option}" :disabled="!option || sending">SEND <i class="fas fa-spinner fa-spin text-secondary" v-if="sending"></i></button>
			</div>

			<ul class="my-2" v-if="selected_workers.length > 1">
				<li v-for="worker_id in selected_workers" :key="worker_id">
					{{ $worker.getName(worker_id) }}
				</li>
			</ul>

			<div class="form-group">
				<label>Message</label>
				<select v-model="option" class="form-control">
					<option value=""></option>
					<option value="buzz">Buzz Asset</option>
					<option value="message">Are you ok?</option>
					<option value="planning">Go to planning zone</option>
				</select>
			</div>
		</form>

	</b-modal>
</template>

<script>
	import { mapState } from 'vuex';
	import eventHub from '../../plugins/eventHub';


	export default {
		name: "Message",
		data() {
			return {
				option: null,
				sending: false,
				action_to: null,
				labels: {
					'buzz': "Asset {{name}} buzzed successfully.",
					'message':  "Instant message to asset {{name}} has been sent successfully.",
					'planning': "Asset {{name}} was directed to planning zone successfully."
				}
			}
		},
		computed: {
			show_message: {
				get() { return this.$store.state.show_message},
				set(value) { this.$store.commit('setState', ['show_message', value])}
			},
			selected_workers: {
				get() { return this.$store.state.selected_workers},
				set(value) { this.$store.commit('setState', ['selected_workers', value])}
			},
			map() {
				return this.$store.state.map.map
			},
			...mapState([
				'workers',
				'messages',
				'flash',
				'lock',
				'day',
				'time',
				'sprites'
			]),
		},
		watch: {
			messages: {
				handler() {
					for (let worker_id in this.messages) {
						let messages = this.messages[worker_id];
						for (let j in messages) {
							let message = messages[j];
							if (!message.notified) {
								this.$noty.success(this.labels[message.type].replace(/\{\{name\}\}/g, this.$worker.getName(worker_id)));
								message.notified = true;
							}
							if (message.response && message.response.value && !message.response.notified) {
								let type = message.response.type ? message.response.type : 'info';
								this.$noty[type](message.response.value.replace(/\{\{name\}\}/g, this.$worker.getName(worker_id)));
								message.response.notified = true;
							}
						}

					}
				},
				deep: true
			}
		},
		methods: {
			submit() {
				if (!this.option) return;
				this.sending = true;

				setTimeout(() => {
					for (let i in this.selected_workers) {
						let worker_id = this.selected_workers[i];
						let worker = this.workers[worker_id];
						this[this.option](worker, this.selected_workers.length);
					}
					this.selected_workers = [];
					this.option = null;
					this.show_message = false;
					this.sending = false;

				}, 1000);
			},
			buzz(item, count) {
				eventHub.$emit('buzz', item.id);

				if (count == 1) {
					let center = item.coordinates;
					this.map.getView().animate({
						center: center,
						zoom: 20,
						duration: 1000
					});
					this.floor_level = item.floor_level;
				}

				if (!this.messages[item.id]) this.$set(this.messages, item.id, []);
				this.messages[item.id].push({'type': 'buzz', 'response': {}, day: this.day, time: this.time});

				var index = this.messages[item.id].length - 1;
				let duration = Math.floor(Math.random()*(10000 - 5000 +1)+5000);

				this.$set(this.flash, item.id, {
					id: item.id,
					flash: 'buzz',
					duration: duration
				});

				let $sprite = this.sprites[item.id];
				$sprite.setSpeed(0);

				setTimeout(() => {
					this.$set(this.flash, item.id, null);
					this.messages[item.id][index].response = {value: 'Asset {{name}} buzzed back.', day: this.day, time: this.time};
					let $sprite = this.sprites[item.id];
					$sprite.setSpeed(item.speed);
				}, duration)


			},
			planning(item) {
				if (!this.messages[item.id]) this.$set(this.messages, item.id, []);

				this.messages[item.id].push({'type': 'planning', 'response': {}, 'day': this.day, 'time': this.time, 'status': 'going'});

				item.override = 'planning';
				this.$set(this.lock, item.id, {
					zone: 'planning',
					duration: 1800,
					start: null
				});
				this.$set(this.flash, item.id, null);
				let $sprite = this.sprites[item.id];
				$sprite.setSpeed(item.speed);
			},
			message(item) {

				var duration = this.$number.random(30000, 5000);

				var responses = [
					{
						label: 'I am Ok.',
						type: 'info'
					},
					{
						label: 'I need assistance.',
						type: 'warning'
					}
				];

				if (!this.messages[item.id]) this.$set(this.messages, item.id, []);
				this.messages[item.id].push({'type': 'message', 'response': {}, day: this.day, time: this.time});

				var $sprite = this.sprites[item.id];
				$sprite.setSpeed(0);

				var index = this.messages[item.id].length - 1;
				var response = this.$finder.random(responses);

				setTimeout(() => {
					this.$set(this.flash, item.id, null);

					this.messages[item.id][index].response = {type: response.type, value: "Asset {{name}} replied: "+response.label, day: this.day, time: this.time};
					$sprite.setSpeed(item.speed);
				}, duration)
			}
		}
	}
</script>
